'use strict'
import TableColumn from './TableColumn.js';
import TableColumns from './TableColumns.js';
import ColumnSet from './ColumnSet.js';
import TableColumnsFactory from './TableColumnsFactory.js';

/**
 * 2. Set LargestPeak flag
 * 3. Go through each chromatogram and calculate number of peaks
 * 4. Generate column names and expressions for N of peaks and LargestPeak
 * 5. Generate Injection and Structure-level column names
 */
export default class PeaksAsRowsColumnsFactory {
    /**
     * @returns {TableColumns}
     */
    static createColumns() {
        const columns = new ColumnSet();
        columns.putAll(TableColumnsFactory._createInjectionColumns());
        columns.putAll(PeaksAsRowsColumnsFactory.createPeakLevelColumns());
        columns.putAll(PeaksAsRowsColumnsFactory.createSubstanceLevelColumns());
        columns.put(new TableColumn('Chromatogram name', 'chromatogram.name', {type:"string"}));
        return new TableColumns(columns.getSorted());
    }

    /**
     * @private
     */
    static createPeakLevelColumns() {
        const columns = new ColumnSet();
        columns.put(new TableColumn("Area", "peak.area", {type:"number"}));
        columns.put(new TableColumn("Area%", "peak.areaPercent", {type:"number"}));
        columns.put(new TableColumn("RT min", "peak.rt", {type:"number"}));
        columns.put(new TableColumn("LargestPeak", "peak.largestPeak", {type:"string"}));
        columns.put(new TableColumn("Start min", "peak.start", {type:"number"}));
        columns.put(new TableColumn("End min", "peak.end", {type:"number"}));
        columns.put(new TableColumn("Base", "peak.base", {type:"number", autoDetectType:false}));
        columns.put(new TableColumn("IsManual", "peak.isManual", {type:"boolean", title: "Whether the peak was detected automatically or was selected/modified manually"}));
        columns.put(new TableColumn('Unknown', 'peak.isUnknown', {type:"boolean", title: "Whether the peak is not assigned to any substance"}));
        return columns.getSorted();
    }

    /**
     * @private
     */
    static createSubstanceLevelColumns() {
        const columns = new ColumnSet();
        columns.put(new TableColumn('MF', 'substance.mf', {type:"string"}));
        columns.put(new TableColumn('EMW', 'substance.emw', {type:"number"}));
        columns.put(new TableColumn('Struct', 'substance.structure', {type:"svg"}));
        columns.put(new TableColumn('Alias', 'substance.alias', {type:"string"}));
        return columns.getSorted();
    }
}